var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGauge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M29.9,9.4c-2.3-1.2-4.8-1.8-7.4-1.8C13.4,7.6,6,15,6,24.2c0,2.6,0.6,5.2,1.8,7.5c0.2,0.2,0.4,0.4,0.7,0.4 H11l2.1,4.8c0.1,0.3,0.4,0.5,0.7,0.5h17.3c0.3,0,0.6-0.2,0.6-0.5l2.2-4.8h2.6c0.3,0,0.6-0.2,0.7-0.4C41.4,23.5,38.1,13.5,29.9,9.4z  M36.2,30.7H8.9c-0.8-1.8-1.3-3.8-1.4-5.8h3.1c0.4,0.1,0.7-0.2,0.8-0.6c0,0,0-0.1,0-0.1c0-0.4-0.3-0.7-0.7-0.8H7.5 c0.2-3.5,1.6-6.8,3.9-9.3l2.2,2.2l0.6,0.2l0.5-0.2c0.3-0.3,0.3-0.8,0-1.1L12.5,13c2.5-2.3,5.8-3.7,9.3-3.9v3.2 c0.1,0.4,0.4,0.7,0.8,0.7c0.4,0,0.7-0.3,0.7-0.7V9.1c3.5,0.2,6.8,1.6,9.4,3.9l-2.2,2.2c-0.3,0.3-0.3,0.8,0,1.1l0.5,0.2l0.5-0.2 l2.2-2.2c2.4,2.5,3.8,5.8,3.9,9.3h-3.1c-0.4,0-0.8,0.4-0.8,0.8c0,0.4,0.3,0.7,0.7,0.7c0,0,0.1,0,0.1,0h3.1 C37.5,26.9,37,28.9,36.2,30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M37.5,24.9h-3.1c0,0-0.1,0-0.1,0c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.4-0.8,0.8-0.8h3.1 c-0.1-3.5-1.5-6.8-3.9-9.3l-2.2,2.2L31,16.5l-0.5-0.2c-0.3-0.3-0.3-0.8,0-1.1l2.2-2.2c-2.6-2.3-5.9-3.7-9.4-3.9v3.2 c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.8-0.7V9.1c-3.5,0.2-6.8,1.6-9.3,3.9l2.2,2.2c0.3,0.3,0.3,0.8,0,1.1l-0.5,0.2l-0.6-0.2 l-2.2-2.2c-2.3,2.5-3.7,5.8-3.9,9.3h3.2c0.4,0.1,0.7,0.4,0.7,0.8c0,0,0,0.1,0,0.1c-0.1,0.4-0.4,0.6-0.8,0.6H7.5 c0.1,2,0.6,4,1.4,5.8h27.3C37,28.9,37.5,26.9,37.5,24.9z M24.9,24.2C24.9,24.2,24.9,24.2,24.9,24.2c0,1.3-1,2.3-2.3,2.3 s-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3l1,0.2l3.5-3.5c0.3-0.3,0.8-0.3,1.1,0c0.2,0.3,0.2,0.7,0,1l-3.6,3.6 C24.8,23.5,24.9,23.8,24.9,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M28.2,18.6c-0.3-0.3-0.8-0.3-1.1,0l-3.5,3.5l-1-0.2c-1.3,0-2.3,1-2.3,2.3c0,1.3,1,2.3,2.3,2.3 s2.3-1,2.3-2.3c0,0,0,0,0,0c0-0.4-0.1-0.7-0.3-1l3.6-3.6C28.4,19.3,28.4,18.9,28.2,18.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge);
export default __webpack_public_path__ + "static/media/gauge.5fd661506e15add18dde3b9b58fbf2fc.svg";
export { ForwardRef as ReactComponent };